module.exports = __webpack_public_path__ + "media/images/flags/4x3/lux-f40a33152d2c329370a9a80a93e7945e.svg";